import React from 'react';

const PagoOk: React.FC = () => {
    return (
        <div className="pago-ok">
            <h1>Reserva confirmada</h1>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Gracias por su compra.</p>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Su reserva ha sido confirmada.</p>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>En breve recibira la confirmación de la reseva en tu cuenta de correo electrónico.</p>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Si no recibes la confirmación ponte en contacto con nosotros llamando al 666 222 269</p>
            <a href="https://www.hankyplanet.com">Volver a la página principal</a>
        </div>
    );
};

export default PagoOk;
